<template>
  <v-container class="fill-height pa-0" fluid style="margin-top:-85px !important;">
    <img src="images/login-bg.jpg" alt="" style="position: absolute; left: 0; width: 100%; height: 100%">
    <!-- <img
      src="images/login-bg.jpg"
      alt=""
      style="position: absolute; left: 0; max-width: 1366px;height: 950px;"
    /> -->
    <v-row align="center" justify="center" class="pa-0 ma-0">
      <v-col cols="4">
        <v-card class="elevation-4" 
        :loading="loading"
         width="100%"
        >
          <v-toolbar color="primary" dark flat dense>
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div class="error--text text-center" style="font-size:18px; line-height: 25px;" v-if="ip_not_allow">
              We need to Validate your Login<br>
              Please Press Send Code Button <br>
              <v-btn color="primary text-capitalize mt-2 mb-2" small="" @click="sendOTP" :loading="send_opt_loading">Send Code</v-btn>
            </div>
            <div class="primary--text text-center" style="font-size:18px; line-height: 25px;" v-if="enter_otp_button">
              We have sent you code on your<br> 
              Mobile Phone No. ending {{last_for_digit_number}}<br>
              <v-btn color="primary text-capitalize mt-2 mb-2" small="" @click="send_otp_dialog = true">Enter Code</v-btn>
            </div>
            <v-form>
              <v-text-field
              label="User name"
              name="login_name"
              prepend-icon="mdi-account"
              type="text"
              v-model="login_name"
              :error-messages="form_error.login_name"
              ></v-text-field>
              <v-text-field
                id="password"
                label="Password"
                name="password"
                v-model="password"
                prepend-icon="mdi-lock"
                type="password"
                :error-messages="form_error.password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text>Forgot Password?</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="login" :loading="loading">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-footer
      fixed 
      padless
      class="primary white--text custom-footer-width"
      height="30"
    >
      <v-col
        class="text-center pa-0"
        cols="12"
      >
        Copyright © {{ new Date().getFullYear() }} — <strong>Build Well, LLC</strong>
      </v-col>
    </v-footer>

    <v-dialog v-model="send_otp_dialog" max-width="330" persistent>
      <v-card
        class="mx-auto align-self-stretch"
        tile
        :loading="send_opt_loading"
        width="100%"
      >
        <v-card-title class="headline justify-center">Enter OTP</v-card-title>
        <v-card-text class="pa-2 pt-0 mt-0 pb-0 mb-0">
            <v-form>
              <v-row dense="">
                <v-col cols="4" class="mx-auto">
                  <v-text-field
                    v-model="otp"
                    outlined=""
                    dense
                    :error-messages="otp_error"
                    :hide-details="otp_error"
                    v-mask="'######'"
                  >  
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
        </v-card-text>
        <v-card-subtitle class="pt-2 text-center">
          <v-btn
            color="primary"
            dark
            outlined
            @click="sendOTP"
            :loading="send_opt_loading"
            small=""
            class="text-capitalize"
            >
            <v-icon left>
              mdi-reload
            </v-icon>Re-send OTP
          </v-btn>
        </v-card-subtitle>
        <v-card-actions class="pt-0 mt-0">
          <v-btn color="error" dark @click="send_otp_dialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="addIp"
            :loading="send_opt_loading"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      form_error: {},
      login_name: "",
      password: "",
      ip_not_allow: false,
      user_id: null,
      company_id: null,
      last_for_digit_number: null,
      enter_otp_button: false,
      send_otp_dialog: false,
      send_opt_loading: false,
      otp: null,
      otp_error: null
    };
  },
  computed : {
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    sendOTP() {
      this.send_opt_loading = true
      let _self = this;
      this.$axios
        .post("send_otp", {user_id: this.user_id, company_id: this.company_id})
        .then((res) => {
          let data = res.data;
          if (data.status) {
            _self.last_for_digit_number = data.last_for_digit_number
            _self.enter_otp_button = true
            _self.ip_not_allow = false
          }
          _self.send_opt_loading = false
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.send_opt_loading = false
        });
    },
    addIp() {
      this.send_opt_loading = true
      let _self = this;
      this.$axios
        .post("add_id", {user_id: this.user_id, otp: this.otp, company_id: this.company_id})
        .then((res) => {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.otp_error = data.errors[key][0];
            }
          } else {
            _self.form_error = {}
            _self.ip_not_allow = false
            _self.user_id = null
            _self.company_id = null
            _self.last_for_digit_number = null
            _self.send_otp_dialog = false
            _self.otp = null
            _self.otp_error = null
            _self.enter_otp_button = false
            _self.setAlert({
              show: true,
              variant: "primary",
              message: data.message,
              dismissCountDown: 0
            });
          }
          _self.send_opt_loading = false
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.send_opt_loading = false
        });
    },
    login() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      this.$axios
        .post("login", this._data)
        .then((res) => {
          let data = res.data;
          if (!data.status) {
            if(data.errors) {
              for (let key in data.errors) {
                _self.form_error[key] = data.errors[key][0];
              }
            } else {
              this.ip_not_allow = true;
              this.user_id = data.user_id
              this.company_id = data.company_id
            }
          } else {
            localStorage.setItem("token", data.access_token);
            localStorage.setItem("user_name", data.user_data.full_name);
            localStorage.setItem("user_id", data.user_data.user_id);
            localStorage.setItem("user_is_main_admin", data.user_data.is_main_admin);
            localStorage.setItem("company_data", JSON.stringify(data.company_data));
            this.$axios.defaults.headers.common = {
              "Authorization": "Bearer " + data.access_token
            };
            _self.$router.push({ path: '/dashboard' })
            // location.reload();
          }
          _self.loading = false;
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },
  },
};
</script>
<style>
.v-main {
    padding: none !important;
}
</style>